import { Option } from "@siteimprove/alfa-option";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Rule } from "../rule.js";
/**
 * @public
 */
export class NamespaceRule extends Rule {
    static of(namespace, prefix) {
        return new NamespaceRule(namespace, prefix);
    }
    _namespace;
    _prefix;
    constructor(namespace, prefix) {
        super("namespace");
        this._namespace = namespace;
        this._prefix = prefix;
    }
    get namespace() {
        return this._namespace;
    }
    get prefix() {
        return this._prefix;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            namespace: this._namespace,
            prefix: this._prefix.getOr(null),
        };
    }
    toString() {
        const prefix = this._prefix.map((prefix) => ` ${prefix}`).getOr("");
        return `@namespace ${prefix}url(${this._namespace})`;
    }
}
/**
 * @public
 */
(function (NamespaceRule) {
    function isNamespaceRule(value) {
        return value instanceof NamespaceRule;
    }
    NamespaceRule.isNamespaceRule = isNamespaceRule;
    /**
     * @internal
     */
    function fromNamespaceRule(json) {
        return Trampoline.done(NamespaceRule.of(json.namespace, Option.from(json.prefix)));
    }
    NamespaceRule.fromNamespaceRule = fromNamespaceRule;
})(NamespaceRule || (NamespaceRule = {}));
//# sourceMappingURL=namespace.js.map